import {atom} from "jotai";

type UiNavigationState = {
  /*
    If this is set, then we must poll instantly for incoming video chat requests.
     If there are any, we must show nudge icon (blinking etc.)
   */
  incomingVideoChatPollNow : boolean
}

export const uiNavigationState = atom<UiNavigationState>({incomingVideoChatPollNow:false})



